import React from 'react';

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='15'
      height='13'
      viewBox='0 0 30 30'
    >
      <path d='M14.984 5a1 1 0 00-.691.293l-10 10a1 1 0 101.414 1.414L15 7.414l9.293 9.293a1 1 0 101.414-1.414l-10-10A1 1 0 0014.984 5zm0 7a1 1 0 00-.691.293l-10 10a1 1 0 101.414 1.414L15 14.414l9.293 9.293a1 1 0 101.414-1.414l-10-10a1 1 0 00-.723-.293z'/>
    </svg>
  );
}

export default Icon;
